import React, { useState, useEffect } from 'react';

export interface SlideItem {
  image: string;
  title: string;
  description: string;
}

export const defaultSlides: SlideItem[] = [
  {
    image: '/assets/images/slider-img 1.svg',
    title: 'Effortless Voting Anytime, Anywhere',
    description: 'Cast your vote securely from the comfort of your home or on the go. Electpoll ensures a seamless experience, eliminating long queues and travel.',
  },
  {
    image: '/assets/images/slider-img 2.svg',
    title: 'Robust Security for Every Vote',
    description: 'Rest easy knowing that state-of-the-art security measures protect your vote. Our advanced encryption and authentication protocols ensure the integrity of the electoral process.',
  },
  {
    image: '/assets/images/slider-img 3.svg',
    title: 'Transparency You Can See',
    description: 'Experience an unprecedented level of transparency in elections. With Electpoll, you can track your vote and verify its inclusion in the final tally.',
  },
];

export const completedSlides: SlideItem[] = [
  {
    image: '/assets/images/slider-img 4.svg',
    title: 'Accessible Voting for All',
    description: 'Electpoll ensures that every eligible voter can participate in the electoral process, regardless of physical ability or location.',
  },
  {
    image: '/assets/images/slider-img 5.svg',
    title: 'Verified Voter Identification',
    description: 'Secure elections begin with verified voter identities. Our e-voting system employs a robust and reliable identification process, ensuring that only eligible voters participate.',
  },
  {
    image: '/assets/images/slider-img 6.svg',
    title: 'Streamlined Voters Management',
    description: 'Efficiency meets accuracy with our voter list upload feature. Election officials can effortlessly upload lists of eligible voters, streamlining identification processes.',
  },
];

interface SliderSectionProps {
  slides?: SlideItem[];
}

export const SliderSection: React.FC<SliderSectionProps> = ({ slides = defaultSlides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="sub-sliders">
      {slides.map((s, idx) => (
        <div
          key={idx}
          className="slider"
          style={{ display: currentSlide === idx ? 'block' : 'none' }}
        >
          <div
            className="slider-img"
            style={{ backgroundImage: `url("${s.image}")` }}
          ></div>
          <div className="slider-texts">
            <h2>{s.title}</h2>
            <p>{s.description}</p>
          </div>
        </div>
      ))}
      <div className="slider-indicator">
        {slides.map((_, idx) => (
          <div
            key={idx}
            className={`si-dot ${currentSlide === idx ? 'active-dot' : ''}`}
            onClick={() => setCurrentSlide(idx)}
          ></div>
        ))}
      </div>
    </div>
  );
};
